import { Row, Col } from "reactstrap";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import {
    crearOEditarCargo,
    selectTipoCargos,
} from "../../services/cargos-service";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";

const FormCargos = ({ modalState, onSave }) => {
    const { cargo } = modalState.data;
    const [tiposCargos, setTiposCargos] = useState([]);

    const defaultValues = {
        id: cargo.id || "",
        nombre: cargo.nombre || "",
        parametro_tipo_cargo: cargo.nombre_tipo_cargo
            ? {
                  label: cargo.nombre_tipo_cargo,
                  value: cargo.parametro_tipo_cargo,
              }
            : "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [cargo]);

    const onCreateCargo = async (cargo) => {
        cargo.parametro_tipo_cargo = cargo.parametro_tipo_cargo.value;
        const resp = await crearOEditarCargo(cargo);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    useEffect(async () => {
        const resp = await selectTipoCargos();
        if (!resp.status) return toast.error(resp.message);

        const tiposCargos = resp.data.map((nombre_tipo_cargo) => {
            return {
                value: nombre_tipo_cargo.id,
                label: nombre_tipo_cargo.nombre,
            };
        });

        setTiposCargos(tiposCargos);
    }, []);

    return (
        <FormModal
            size="lg"
            form={form}
            id="formCargo"
            onSubmit={onCreateCargo}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        name="nombre"
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Nombre"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        options={tiposCargos}
                        label="Tipo Cargo"
                        errors={form.formState.errors}
                        control={form.control}
                        name="parametro_tipo_cargo"
                        rules={{ required: "Este campo es requerido" }}
                        placeholder="Tipo Cargo"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormCargos.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormCargos;
